import api from "./apiService";

export function getSubscriptions(page, limit, status) {
  return api
    .get(`admin/subscriptions/?page=${page}&limit=${limit}&status=${status}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export async function getSubscriptionDetail(id) {
  return api
    .get(`admin/subscriptions/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function declineExcessCharge(id, data) {
  return api
    .patch(`admin/subscriptions/extra-charge/decline/${id}`, data)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function approveExcessCharge(id) {
  return api
    .patch(`admin/subscriptions/extra-charge/approve/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function cancelSub(id) {
  return api
    .patch(`admin/subscriptions/cancel-subscription/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function reactivateSub(id, data){
  return api 
  .patch(`/admin/subscriptions/${id}`, data)
  .then(data => {
    return data.data
  })
  .catch(err => {
    throw err;
  });
}

export function markExtraChargePaid(id) {
  return api
    .patch(`admin/subscriptions/extra-charge/mark-as-paid/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export async function getSetup() {
  return api
    .get(`subscriptions/get-setup/`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export async function addExtraCharge(data) {
  return api
    .post(`admin/subscriptions/extra-charge/`, data)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export async function editExtraCharge(payload, id) {
  return api
    .patch(`admin/subscriptions/edit-extra-charge/${id}`, payload)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function deleteExtraCharge(payload, id) {
  return api
    .patch(`admin/subscriptions/delete-extra-charge/${id}`, payload)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/subscription.js
// module id = null
// module chunks = 